import type {
  ActivityAvailabilityCriteria,
  GraphQL,
} from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getMarketOrigin } from '../../utils';

import { getInputPaxGroupQL } from './inputPaxGroupQL';

export function getTicketRequestQL(
  activityAvailabilityCriteria: ActivityAvailabilityCriteria
): GraphQL.TicketRequestQL {
  return {
    code: activityAvailabilityCriteria.userCriteria.productCode,
    fromDateOnly: normalizeDateOnlyString(
      activityAvailabilityCriteria.userCriteria.startDate
    ),
    toDateOnly: normalizeDateOnlyString(
      activityAvailabilityCriteria.userCriteria.endDate
    ),
    market: getMarketOrigin(),
    pax: getInputPaxGroupQL(activityAvailabilityCriteria.userCriteria.pax),
    affiliateId: activityAvailabilityCriteria.businessCriteria.affiliateId,
  };
}
